module.exports = __webpack_public_path__ + "images/manifestum/gic.62faf358.png";